import Swiper, {Navigation, Pagination} from 'swiper'

Swiper.use([Navigation, Pagination])

const sliders = []

let slidersHtml = document.querySelectorAll('.slider')

const playVideo = (swiper) => {
  let videoEl = swiper.el.querySelector('.swiper-slide.swiper-slide-active video')
  if (videoEl) {
    videoEl.play()
    return videoEl
  }

  return false
}

const pauseVideos = (swiper) => {
  let videosEl = swiper.el.querySelectorAll('.swiper-slide video')
  if (videosEl.length) {
    videosEl.forEach(videoEl => {
      videoEl.pause()
      videoEl.currentTime = 0
    })
  }
}

if (slidersHtml.length) {
  slidersHtml.forEach(sliderHtml => {
    sliders.push(new Swiper(sliderHtml, {
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      watchOverflow: true,
      autoHeight: true,
      on: {
        slideChangeTransitionStart: pauseVideos,
        slideChangeTransitionEnd: swiper => {
          let video = playVideo(swiper)
          if (video) {
            video.muted = false
          }
        },
        init: playVideo
      }
    }))
  })
}

const archiveSwiper = document.querySelector('.archive-slider');

if (archiveSwiper) {
  new Swiper(archiveSwiper, {
    slidesPerView: 1.5,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      450: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 480px
      680: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      // when window width is >= 640px
      1050: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    }
  })
}




// WEBPACK FOOTER //
// ./scripts/modules/slider.js